import React from 'react';
import { Card, CardHeader, CardContent, CardActionArea, Box, List, ListItem, Divider } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ButtonNav from '../button/ButtonNav';

export default function CardProduit({ prestation, produit }) {

	return (
		<>
			<Card sx={{ color: '#555555', backgroundColor: '#F7F7F7', borderRadius: 0, boxShadow: 10 }} >
				<CardActionArea className="book-link" href={process.env.REACT_APP_CATALOGUE_URL + '/' + prestation.key + '/' + produit.key + '/'}>
					<CardHeader
						sx={{ height: '80px', backgroundColor: '#004AFE', color: '#FFFFFF', textAlign: 'center' }}
						titleTypographyProps={{ fontSize: 18, fontWeight: 600 }}
						title={produit.contenu.titreCourt}
						subheader={prestation.contenu.titre}
						subheaderTypographyProps={{ color: '#FFFFFF', fontSize: 12, fontWeight: 400 }}
					/>
					<CardContent>
						{
							/**
							<Typography component="div" align="center" variant="price">
								{produit.contenu.prixDepart}<Typography component="span" align="center" variant="currency">€</Typography>
							</Typography>
							<Typography component="div" align="center" variant="price_from">
								à partir de
							</Typography>
							 */
						}

						<List sx={{ mt: 2 }}>
							{
								// Boucle sur la liste des détails
								produit.contenu.descriptionListe.map(function(element, index, arr) {
									return (
										<React.Fragment key={index}>
											<ListItem>
												<CheckCircleOutlineIcon sx={{ mr: 2 }} />{element}
											</ListItem>
											{(arr.length - 1 !== index) &&
												<Divider sx={{ backgroundColor: '#abb8c3', m: 1, height: 1 }} />
											}
										</React.Fragment>
									)
								})
							}
						</List>
					</CardContent>

					<Box textAlign='center' paddingBottom={4}>
						<ButtonNav props={{ text: 'Réserver votre Rendez-vous' }} />
					</Box>
				</CardActionArea>
			</Card>
		</>
	);
}